var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{ref:"videoDiv",staticClass:"video"},[_c('videoPlayer',{ref:"videoPlayer",staticClass:"video-player-box",attrs:{"options":_vm.playerOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }